import {RoutingTableType} from '@supermove/navigation/src/';

// This will look like [Routes.GenericRouteName]: '/manager-route/:pathParam'
const routingTable: RoutingTableType = {};

export default routingTable;
